import { render, staticRenderFns } from "./ColumnUserInfo.vue?vue&type=template&id=4c8fbd7c"
import script from "./ColumnUserInfo.vue?vue&type=script&lang=js"
export * from "./ColumnUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports